import { useLocation } from "react-router-dom";
import css from "./leftmenu.module.css";

import { Sidebar } from "./Sidebar";
import { SidebarCollapsed } from "./SidebarCollapsed";
import { ResearchBar } from "./ResearchBar";

export const LeftMenu = (props) => {
  const { pathname } = useLocation();

  let className = css.container;
  if (!props.isMenuVisible) {
    className = css.collapsed;
  }

  function getSidebar() {
    switch (true) {
      case pathname.split("/")[1] === "researcher":
        return props.isMenuVisible && <ResearchBar />;
      default:
        return props.isMenuVisible ? <ResearchBar /> : <SidebarCollapsed />;
    }
  }

  return (
    <div className={className} onMouseLeave={props.onMouseLeave}>
      {getSidebar()}
    </div>
  );
};
